import { useState, useCallback } from 'react';

export const TABS = {
  CARDS: 'CARDS',
  FLIGHTS: 'FLIGHTS',
  LOYALTY: 'LOYALTY',
  MORE: 'MORE',
};

export const SUB_SCREENS = {
  FLIGHT_RESULTS: 'FLIGHT_RESULTS',
  PURCHASE_STRATEGIES: 'PURCHASE_STRATEGIES',
  TRANSFER_REFERENCE: 'TRANSFER_REFERENCE',
};

export function useTabNavigation(initialTab = TABS.CARDS) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [subScreen, setSubScreen] = useState(null);
  const [subScreenData, setSubScreenData] = useState(null);

  const navigateToTab = useCallback((tab) => {
    setActiveTab(tab);
    setSubScreen(null);
    setSubScreenData(null);
  }, []);

  const navigateToSubScreen = useCallback((screen, data = null) => {
    setSubScreen(screen);
    setSubScreenData(data);
  }, []);

  const goBack = useCallback(() => {
    if (subScreen) {
      setSubScreen(null);
      setSubScreenData(null);
    }
  }, [subScreen]);

  return {
    activeTab,
    subScreen,
    subScreenData,
    navigateToTab,
    navigateToSubScreen,
    goBack,
  };
}
